import React, {Component} from 'react'
import moment from 'moment'
import Segment from '../../../Segment'
import GistLogo from '../../../GistLogo'
import {isMobile, isMobileOnly} from 'react-device-detect'
import styled from '@emotion/styled'
import sv from '../../../../styles/styles'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Eye, EyeOff, List} from 'react-feather'
import VolumeControl from './VolumeControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Replay10SharpIcon from '@material-ui/icons/Replay10Sharp';
import Forward10SharpIcon from '@material-ui/icons/Forward10Sharp';
import Radio from '@material-ui/core/Radio';
import {withTranslation} from "react-i18next";
import {playerActions} from "../../../../_actions/player.actions";
import {connect} from "react-redux";
import {faSearch, faSpinner} from "@fortawesome/free-solid-svg-icons";

// STYLE ##########################################################

const TimelineContainer = styled('div')`
  position: relative;
  border-radius: 4px;
  padding-top: 16px;
  touch-action: none;
  ${sv.box};
  ${sv.flexColumn};
`;

const ProgressBar = styled('div')`
  flex: 0 0 20px;
  width: 100%;
  position: relative;
  ${sv.flexCenter};
  .progress-empty {
    background: rgba(255, 255, 255, .2);
    position: relative;
    width: 100%;
    height: 6px;
  }
  .progress {
    position: absolute;
    width: ${props => props.position}%;
    height: 100%;
    pointer-events: none;
    background: ${sv.colors.cta};
  }
`;

const ScrubArea = styled(`div`)`
  height: ${props => props.isScrubbing ? '500px' : '100%'};
  width: 100%;
  position: absolute;
  bottom: ${props => props.isScrubbing ? '-20px' : '0'};
`;

const TimeDisplay = styled(`div`)`
  color: ${sv.colors.subtleLight};
  ${sv.label};
  white-space: nowrap;
`;

const ChapterDropdown = styled(`div`)`
  padding: 4px 8px;
  background: rgba(100,100,100,.75);
  color: rgba(255,255,255,.75);
  border-radius: 4px;
  ${sv.label};
  ${sv.flexRow};
  cursor: pointer;
  &:hover {
    background: rgba(150,150,150,.75);
  }
  span {
    padding-right: 5px;
    white-space: nowrap;
  }
`;

const Tick = styled(`div`)`
  width: ${props => props.activeSearchHit ? '9px' : '1px'};
  height: ${props => props.activeSearchHit ? "24px" : "20px"};
  ${props => props.activeSearchHit ? "border-radius: 0 0 4.5px 4.5px;" : ""}
  ${props => props.activeSearchHit ? "margin-left: -4px;" : ""}
  ${props => props.activeSearchHit ? 'z-index: 1550' : ''};
  background: ${props => props.activeSearchHit ? "rgba(100,100,100,.75)" : (props.activeHit ? sv.colors.cta : sv.colors.subtleLight)};
  position: absolute;
  left: ${props => props.position}%;
  bottom: 0px;
  display: flex;
  justify-content: center;
`;

const TickCenter = styled(`div`)`
  width: 1px;
  height: 16px;
  background-color: ${sv.colors.cta};
  position: relative;
  top: 5px;
`;

const TimelineControls = styled(`div`)`
  flex: 1;
  flex-wrap: wrap;
  ${sv.flexRow};
  justify-content: space-between;
`;

const Controls = styled(`div`)`
  display: flex;
  flex-direction: inherit;
  padding: 2px 0;
  ${sv.flexRow};
  justify-content: ${props => props.left ? 'flex-start' : (props => (props.center || props.centerFull) ? 'space-around' : 'flex-end')};
  order: ${props => props.left ? '0' : (props => (props.center || props.centerFull) ? '1' : '2')};
  ${props => (props.doubleTier && props.searchActive && props.center) ? "order: 1" : ""};
  ${props => (props.doubleTier && !props.searchActive && props.center) ? "flex: 0 0 100%" : ""};
  ${props => (props.doubleTier && !props.searchActive && props.center) ? "order: 3" : ""};
  ${props => (props.doubleTier && props.searchActive && props.centerFull) ? "flex: 0 0 100%" : ""};
  ${props => (props.doubleTier && props.searchActive && props.centerFull) ? "order: 3" : ""};
  ${props => (props.doubleTier && !props.searchActive && props.centerFull) ? "order: 1" : ""};
  ${props => (!props.doubleTier && !props.searchActive ? "width: 33%" : "")};
  flex-grow: ${props => (props.centerFull) ? "1" : "0"};
  > div {   // apply equal margins to all children div
    margin: 0 ${props => props.isMobile ? '10px' : '8px'};
  }
  @media(max-width: 460px) {
    > div {
      margin-left: ${props => props.isMobile ? '5px' : '8px'};
      margin-right: ${props => props.isMobile ? '10px' : '8px'};
    }
  }
`;

const IconButton = styled(`div`)`
  ${sv.flexCenter};
  cursor: pointer;
  height: 100%;
  color: ${sv.colors.light};
  svg {
    transition: all .2s ease-out;
    stroke: ${sv.colors.light};
    opacity: .5;
  }
  &:hover {
    svg {opacity: 1;}
  }
`;

const SkipButton = styled(IconButton)`
  & svg {
    stroke: unset!important;
    margin: 0 -4px;				// to hide affordance on the sides of the underlying logo
  }
`;

const LogoContainer = styled('a')`
  margin: 0 8px;
  opacity: .5;
  &:hover {
    opacity: 1
  }
`;

const PlaybackContainer = styled(FormControl)`
  height: 24px;
  min-width: unset!important;
  & .MuiInputBase-root {
    color:${sv.colors.darkerGray}!important;
    font-size: 14px;
    height: 24px;
    line-height: 1;
    font-weight: 600;
    margin: 0 -6.5px 0 -1px;	// to hide affordances on the sides of the underlying element
  }
  @media(max-width: 400px) {
    display: none;
  }
`;

const PlaybackControl = styled(({ className, ...props }) => (
  <Select {...props}  MenuProps={{
      classes: {paper: className},
      getContentAnchorEl: null,
      container: props.anchor,
      anchorOrigin: {vertical: "top", horizontal: "center" },
      transformOrigin: {vertical: "bottom", horizontal: "center" } }} />
))`
  
  background-color:${sv.colors.subtleGrey};
  min-width: 0;
  padding: 0 4px;
  color: ${sv.colors.darkerGray}!important;
  font-size: 12px!important;
  line-height: unset !important;
  & .MuiList-padding {
    padding-bottom: 1px!important;
  }
`;

const PlaybackOption = styled(MenuItem)`
  min-height: unset!important;
  padding: 1px 4px!important;
  line-height: 1.0!important;
  font-size: 10px!important;
  font-weight: 600!important;
  & .Mui-checked {
    color: ${sv.colors.cta};
  }
  background-color: unset!important;
`;

const PlaybackHeader = styled(PlaybackOption)`
  font-weight: bold!important;
  font-size: 12px!important;
  opacity: 1!important;
  margin-bottom: 3px!important;
`;

const RadioButton = styled(Radio)`
  padding: 1px!important;
  padding-right: 2px!important;
   background-image: unset!important;
  :after {
    content: '${props => props.aftercontent}';
    display: block;
    font-size: 10px;
  }
`;

const RadioIcon = styled(`span`)`    
    border-radius: 50%;
    border: 1.0px solid ${sv.colors.darkerGray};
    width: 12px;
    height: 12px;
    margin-right: 4px;
    input:hover ~ & {
      background-image: radial-gradient(${sv.colors.darkOrange},${sv.colors.darkOrange} 50%,transparent 0%);
    }
`;

const RadioIconChecked = styled(RadioIcon)`
    :before {
      display: block;
      width: 12px;
      height: 12px;
      background-image: radial-gradient(${sv.colors.darkOrange},${sv.colors.darkOrange} 50%,transparent 0%);
      content: '';
    }
`;

const SearchContainer = styled(`div`)`  
  ${sv.flexRow}
  width: 100%;
  padding: 2px 8px;
  background: rgba(100,100,100,.75);
  color: rgba(255,255,255,.75);
  border-radius: 4px;
  &:hover {
    background: rgba(150,150,150,.75);
  }
`;

const SearchItem = styled(`div`)`
  justify-content: ${props => props.left ? 'flex-start' : (props => props.center ? 'center' : 'flex-end')};
  flex-grow: ${props => props.center ? "1" : ""}
`;

const SearchInput = styled(`input`)`
  color: white;
  background-color: unset;
  border: unset;
  padding: 0 10px;
  margin: 0;
  width: 100%;
  
  &:focus {
    outline: none !important;
    border: unset;
  }
  
  // ie fixes
  ::-ms-clear { display: none; width : 0; height: 0; }
  ::-ms-reveal { display: none; width : 0; height: 0; }
  
  // chrome fixes
  ::-webkit-search-decoration { display: none; width : 0; height: 0; }
  ::-webkit-search-cancel-button { display: none; width : 0; height: 0; }
  ::-webkit-search-results-button { display: none; width : 0; height: 0; }
  ::-webkit-search-results-decoration { display: none; width : 0; height: 0; }
`;

// COMPONENT ##########################################################

class Timeline extends Component {

  constructor(props) {
    super(props);
    this.handleChangePlayback = this.handleChangePlayback.bind(this);
    this.state = {
      showSettings: false,
      playback: 1,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if previous search query is still active, then populate it
    const {isSearchActive, searchQuery} = this.props;
    if(isSearchActive && searchQuery !== "" && this.searchElm.value === "") {
      this.searchElm.value = searchQuery;
    }
  }

  handleMouseDown = () => {
    this.props.toggleIsScrubbing()
  };

  handleMouseUp = () => {
    this.props.toggleIsScrubbing()
  };

  handleMouseMove = (e) => {
    if (this.props.isScrubbing) {
      e.stopPropagation();
      // e.preventDefault()
      let rect = e.target.getBoundingClientRect();
      let position = (e.clientX - rect.x) / e.target.offsetWidth * 100;
      if (position > 0 && position < 100) {
        this.props.update(position)
      }
    }
  };

  handleTouchStart = (e) => {
    e.preventDefault();
    this.props.toggleIsScrubbing();
    let rect = e.target.getBoundingClientRect();
    let position = (e.touches[0].clientX - rect.x) / e.target.offsetWidth * 100;
    this.props.update(position)
  };

  handleTouchEnd = (e) => {
    e.preventDefault();
    this.props.toggleIsScrubbing()
  };

  handleTouchMove = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let rect = e.target.getBoundingClientRect();
    let position = (e.touches[0].clientX - rect.x) / e.target.offsetWidth * 100;
    if (position > 0 && position < 100) {
      this.props.update(position)
    }
  };

  handleClick = (e) => {
    e.preventDefault();
    let rect = e.target.getBoundingClientRect();
    let position = (e.clientX - rect.x) / e.target.offsetWidth * 100;
    this.props.update(position)
  };

  handleChangePlayback(event) {
    const speed = event.target.value;
    this.setState({ playback: speed });
    this.props.changePlayback(speed);
    this.props.playerSpeedChange(speed);  // change playback speed event
  };

  togglePlay = () => {
	  if (this.props.videoIsPlaying) {
		  this.props.pauseVideo();
		  this.props.playerPlayPause();
	  } else {
		  this.props.playVideo();
		  this.props.playerPlayResume();
	  }
  };

  toggleGist = () => {
	  this.props.toggleGist();

	  if(this.props.showGist) {
		  this.props.playerGistHide();  // hide gist event
	  } else {
		  this.props.playerGistShow();  // show gist event
	  }
  };

  toggleSearch = () => {
    this.props.toggleSearch();
  };

  handleSearch = (event) => {
    if (event.keyCode === 27)                                 // if 'esc' key, close
      this.toggleSearch();

    const currentValue = this.searchElm.value;                // get the current search query
    const searchValue = currentValue.replace(/\s{2,}/g, ' '); // sanitize 2 or more whitespaces to 1

    if(searchValue !== this.props.searchQuery) {
      this.props.handleSearch(searchValue);                   // search with new value
    }
  };

  formatTrim = (time) => {
    return time._data.hours > 0 ? 'H:mm:ss' : 'm:ss'
  };

  /// RENDER ###################################################################

  render() {
    const {t, showFullControls, showDoubleTierControls, showSemiFullControls, isSearchActive, isSearchOngoing} = this.props;
    const segmentSize = 100 / this.props.chapterCount;
    const segmentPosition = (this.props.currentChapter - 1) * segmentSize;
    const playPauseIcon = this.props.videoIsPlaying ? "pause" : "play";
    const currentTime = moment.duration(this.props.currentTime, 'seconds');
    const totalTime = moment.duration(this.props.totalDuration, 'seconds');
    const currentDisplay = moment.utc(currentTime.asMilliseconds()).format(this.formatTrim(currentTime));
    const totalDisplay = moment.utc(totalTime.asMilliseconds()).format(this.formatTrim(totalTime));
    const showWordTick = !(this.props.wordTimelinePosition === undefined || this.props.wordTimelinePosition === null);
    const showSearchTicks = this.props.isSearchActive && this.props.searchQuery !== '';
    const iconSize = 18;

    return (
      <div className="timeline">
        <TimelineContainer>
          <ProgressBar
            position={this.props.position}
            onTouchStart={(e) => this.handleTouchStart(e)}
            onTouchMove={(e) => this.handleTouchMove(e)}
            onTouchEnd={(e) => this.handleTouchEnd(e)}
            onMouseDown={(e) => this.handleMouseDown(e)}
            onMouseMove={(e) => this.handleMouseMove(e)}
            onMouseUp={(e) => this.handleMouseUp(e)}
            onClick={(e) => this.handleClick(e)}
          >
            <div className="progress-empty">
              <div className="progress"/>
            </div>

            <ScrubArea isScrubbing={this.props.isScrubbing} />

            {this.props.showGist && this.props.cloudCount > 0 &&
              <Segment
                className="segment"
                size={segmentSize}
                position={segmentPosition}
              />
            }

            {/* show word tick */}
            {showWordTick && this.props.cloudCount > 0 &&
            <Tick position={this.props.wordTimelinePosition} activeHit={true} />
            }

            {/* show search ticks */}
            {showSearchTicks &&
              this.props.searchTimelinePositions.map((position, index) =>
                    <Tick key={index} position={position}
                          activeSearchHit={this.props.searchCurrentHit === index+1}>
                      {
                        this.props.searchCurrentHit === index+1 &&
                            <TickCenter/>
                      }
                    </Tick>
              )
            }

          </ProgressBar>

          <TimelineControls>
	          {/* Left Controls */}
            <Controls doubleTier={showDoubleTierControls} searchActive={isSearchActive} isMobile={isMobileOnly} left>

	            {/* Play/ Pause Button */}
              <IconButton title={"Play"} onClick={this.togglePlay}>
                <FontAwesomeIcon icon={playPauseIcon} />
              </IconButton>

	            {/* Time elapsed/ Total Time */}
              <TimeDisplay>{currentDisplay}/{totalDisplay}</TimeDisplay>

	            {/* Skip Back Button */}
	            { showFullControls &&
	            <SkipButton title={"Backwards 10 seconds"} onClick={() => this.props.skipBackwards(false)}>
		            <Replay10SharpIcon/>
	            </SkipButton>
	            }

	            {/* Skip Ahead Button */}
	            { showFullControls &&
	            < SkipButton title={"Forward 10 seconds"} onClick={() => this.props.skipForwards(false)}>
		            <Forward10SharpIcon />
		            </SkipButton>
	            }
            </Controls>

	          {/* Center Controls */}
            <Controls doubleTier={showDoubleTierControls} searchActive={isSearchActive} isMobile={isMobileOnly} center>

	            {/* Chapter Button */}
              {!this.props.screenTooSmallForGist && this.props.showGist &&
              <ChapterDropdown onClick={() => this.props.showTOC()}>
                <span>Chapter {this.props.currentChapter}</span><List size={12}/>
              </ChapterDropdown>
              }
              
            </Controls>

            {/* Center-Full Controls */}
            {isSearchActive &&
            <Controls doubleTier={showDoubleTierControls} searchActive={isSearchActive} isMobile={isMobileOnly} centerFull>
              {/* Search Box */}
              <SearchContainer>
                
                {/* search / loader icon */}
                <SearchItem left>
                  <IconButton>
                    <FontAwesomeIcon
                        icon={(isSearchOngoing) ? faSpinner : faSearch} // show loader on ongoing search
                        spin={isSearchOngoing}
                    />
                  </IconButton>
                </SearchItem>

                {/* search box */}
                <SearchItem center>
                  <SearchInput
                      type={"search"}
                      ref={elm => {this.searchElm = elm}}
                      autoFocus
                      onKeyUp={this.handleSearch}
                      placeholder={t('Search...')}
                  />
                </SearchItem>

                {/* search cancellation */}
                <SearchItem right>
                  <IconButton onClick={this.toggleSearch}><FontAwesomeIcon icon="times" size="sm" color="white"/></IconButton>
                </SearchItem>
              </SearchContainer>
            </Controls>
            }

	          {/* Right Controls */}
            <Controls doubleTier={showDoubleTierControls} searchActive={isSearchActive} isMobile={isMobileOnly} right>

              {!isSearchActive &&
              <>
                {/* Search Controls */}
                { showSemiFullControls &&
                <IconButton title={"Search"} onClick={this.toggleSearch}>
                  <FontAwesomeIcon icon={faSearch}/>
                </IconButton>
                }

                {/* Volume Controls */}
                {!isMobile && showFullControls &&
                <VolumeControl
                    iconSize={iconSize}
                    changeVolume={this.props.changeVolume}
                />}

                {/* PlayBack Speed Controls */}
                { showFullControls &&
                  <PlaybackContainer title={"Video speed"}>
                    <PlaybackControl
                      onChange={this.handleChangePlayback}
                      value={this.state.playback}
                      renderValue={selected => {return selected+'x';}}
                      anchor={this.props.fsElm} >
                      <PlaybackHeader disabled={true}>{t('Speed')}</PlaybackHeader>
                      <PlaybackOption value={.5}><RadioButton size={"small"} checkedIcon={<RadioIconChecked/>} icon={<RadioIcon/>} disableRipple checked={this.state.playback === 0.5} aftercontent={"0.5x"}/></PlaybackOption>
                      <PlaybackOption value={.75}><RadioButton size={"small"} checkedIcon={<RadioIconChecked/>} icon={<RadioIcon/>} disableRipple checked={this.state.playback === 0.75} aftercontent={"0.75x"}/></PlaybackOption>
                      <PlaybackOption value={1}><RadioButton size={"small"} checkedIcon={<RadioIconChecked/>} icon={<RadioIcon/>} disableRipple checked={this.state.playback === 1.0} aftercontent={"Normal"}/></PlaybackOption>
                      <PlaybackOption value={1.25}><RadioButton size={"small"} checkedIcon={<RadioIconChecked/>} icon={<RadioIcon/>} disableRipple checked={this.state.playback === 1.25} aftercontent={"1.25x"}/></PlaybackOption>
                      <PlaybackOption value={1.5}><RadioButton size={"small"} checkedIcon={<RadioIconChecked/>} icon={<RadioIcon/>} disableRipple checked={this.state.playback === 1.5} aftercontent={"1.5x"}/></PlaybackOption>
                      <PlaybackOption value={2}><RadioButton size={"small"} checkedIcon={<RadioIconChecked/>} icon={<RadioIcon/>} disableRipple checked={this.state.playback === 2.0} aftercontent={"2.0x"}/></PlaybackOption>
                    </PlaybackControl>
                  </PlaybackContainer>
                }

                {/* FullScreen / Exit-FullScreen Button */}
                <IconButton title={"Fullscreen"} onClick={() => this.props.toggleFullScreen()}>
                  {!this.props.isFullScreen && <FontAwesomeIcon icon="expand-arrows-alt"/>}
                  {this.props.isFullScreen && <FontAwesomeIcon icon="compress-arrows-alt"/>}
                </IconButton>

                {/* Show / Hide Gist Button */}
                {!this.props.screenTooSmallForGist && !this.props.disableShowHide && showSemiFullControls &&
                <IconButton title={"Show/Hide gist"} onClick={this.toggleGist}>
                  {!this.props.showGist && <Eye size={iconSize}/>}
                  {this.props.showGist && <EyeOff size={iconSize}/>}
                </IconButton>
                }
              </>
              }

              {/* Gist Logo  */}
              <LogoContainer href="https://www.gistify.ai" onClick={() => this.props.playerGistLogoRedirect()}>
	              <GistLogo color={sv.colors.light} width="50px" redirect={false} />
              </LogoContainer>

            </Controls>
          </TimelineControls>
        </TimelineContainer>
      </div>
    )
  }
}

function mapStateToProps() {
	return {}
}

function mapDispatchToProps(dispatch) {
	return {
		playerPlayResume        : ()        => dispatch( playerActions.onPlayPauseBtn(true) ),
		playerPlayPause         : ()        => dispatch( playerActions.onPlayPauseBtn(false) ),
		playerSpeedChange       : (speed)   => dispatch( playerActions.onSpeedChange(speed) ),
		playerGistShow          : ()        => dispatch( playerActions.onGistViewToggle(true) ),
		playerGistHide          : ()        => dispatch( playerActions.onGistViewToggle(false) ),
		playerGistLogoRedirect  : ()        => dispatch( playerActions.onGistLogoRedirect() ),
	}
}

const connectedTimeline = connect(mapStateToProps, mapDispatchToProps) (withTranslation()(Timeline));
export default connectedTimeline;
